import { render } from "./DatasetBenchmarksDesc.vue?vue&type=template&id=36a9cb10"
import script from "./DatasetBenchmarksDesc.vue?vue&type=script&lang=js"
export * from "./DatasetBenchmarksDesc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__